<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle9')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle9') }}</h1>
    <p>{{ $t('artText9-1') }}</p>
    <img
      :src="`${staticUrl}/images/DreamFlat_Where_Your_Dream_Home_Takes_Flight.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText9-2') }}</p>
    <p>{{ $t('artText9-3') }}</p>
    <p>{{ $t('artText9-4') }}</p>
    <p>{{ $t('artText9-5') }}</p>
    <p>{{ $t('artText9-6') }}</p>
    <p>{{ $t('artText9-7') }}</p>
    <p>{{ $t('artText9-8') }}</p>
    <img
      :src="`${staticUrl}/images/DreamFlat_Where_Your_Dream_Home_Takes_Flight_1.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText9-9') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle9')}`,
  ogTitle: `${t('artSeoTitle9')}`,
  description: `${t('artSeoDesc9')}`,
  ogDescription: `${t('artSeoDesc9')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
